export const columns = [
	{
		id: 'id',
		hidden: true,
		label: 'Id',
		width: '350px',
	},
	{
		hidden: true,
		label: 'campaignAnswerId',
		id: 'campaignAnswerId',
		width: '350px',
	},
	{
		id: 'name',
		label: 'Nombre',
		width: '350px',
		hasCollapse: false,
	},
	{
		id: 'position',
		label: 'Puesto',
		width: '200px',
	},
	{
		id: 'branchOfficeName',
		label: 'Sucursal',
		width: '200px',
	},
	{
		id: 'result',
		label: 'Resultado',
		width: '200px',
	},
];
